<div class="container">
	<app-navbar></app-navbar>
	<router-outlet></router-outlet>
	<app-footer></app-footer>
</div>
